module.exports = __webpack_public_path__ + "static/media/printing-services-img1.15ea97ed.jpg";